import {ProductType} from "./product-type.model";
import {ProductVariant} from "./product-variant.model";
import {ShipmentChargeType} from "../../shipment/models/charge-line/shipment-charge-type.enum";
import { AuditActorSummary } from '../../shared/audit/audit.models';

export interface ProductCrmClientItemCode {
    id?: number;
    crmClientId: number;
    clientItemCode: string;
    clientItemDescription?: string;
    active?: boolean;
}

export type ProductLogisticsUsageModule =
    'SHIPMENT_CHARGE' | 'CUSTOMS_CLEARANCE' | 'CONTAINER_YARD' | 'WAREHOUSE_BILLING' |
    'POSM_EXECUTION' | 'LOGISTICS_PROJECT';

export interface ProductLogisticsUsage {
    id?: number;
    productId?: number;
    owningCompanyId?: number;
    usageModule: ProductLogisticsUsageModule;
    operationalCode: string;
    defaultVariantId?: number | null;
    active?: boolean;
    systemStandard?: boolean;
}

export class Products {

    productID: number;
    name: string;
    description: string;
    /** Optional catalog default copied to a new invoice or receivable line. */
    descriptionLocal?: string;
    standardRate: number;
    buyingRate: number;
    sellingRate: number;
    productCode: string;
    productType: ProductType;
    owningCompanyId: number;
    taxRate: number;
    currencyCode: string;
    incomeAccountId?: number | null;
    incomeAccountName?: string;
    expenseAccountId?: number | null;
    expenseAccountName?: string;
    shipmentChargeEnabled?: boolean;
    defaultShipmentChargeType?: ShipmentChargeType | null;
    systemStandard?: boolean;
    productVariants: ProductVariant[];
    crmClientItemCodes?: ProductCrmClientItemCode[];
    logisticsUsages?: ProductLogisticsUsage[];
    inventoryManaged: boolean;
    inventoryProfiles: ProductCatalogInventoryProfile[];

    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date;
    createdBy: number;
    updatedBy: number;
    deletedBy: number;
    createdByActor?: AuditActorSummary;
    updatedByActor?: AuditActorSummary;
    deletedByActor?: AuditActorSummary;

}

export interface ProductCatalogUomConversion {
    id?: number;
    uomId: number;
    usageType: 'PURCHASE' | 'SALES' | 'BOTH';
    factorToBase: number;
    packLabel?: string;
    active?: boolean;
}

export interface ProductCatalogInventoryProfile {
    warehouseItemId?: number;
    productId?: number;
    variantId?: number;
    itemNumber?: string;
    skuNumber?: string;
    stockOwnerType?: 'TENANT_OWNED' | 'CRM_CLIENT_OWNED';
    baseUomId?: number;
    defaultPurchaseUomId?: number;
    defaultSalesUomId?: number;
    defaultWarehouseId?: number;
    defaultConditionId?: number;
    trackingMode?: string;
    shelfLifeDays?: number;
    minimumTemperatureC?: number;
    maximumTemperatureC?: number;
    onHandQuantity?: number;
    reservedQuantity?: number;
    availableQuantity?: number;
    uomConversions?: ProductCatalogUomConversion[];
}
